import React from "react";

import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

class SetAlert extends React.Component {
  statusBadge = {
    Draft: "info",
    Active: "success",
    Fired: "danger",
    Expired: "warning",
  };

  render() {
    const {
      courtAlert: { currentState, date, time, tolerance, courtTypeId, courtSurfaceId },
      staticData,
      onChange,
      onSetAlert,
    } = this.props;

    return (
      <React.Fragment>
        <Container>
          <Row className="justify-content-md-center">
            <Col>
              <h1>
                Court Alerts - Set Alert <Badge bg={this.statusBadge[currentState]}>{currentState}</Badge>
              </h1>
            </Col>
          </Row>
          <Row className="justify-content-flex-start">
            <Col>
              <form onSubmit={this.handleSubmit}>
                <div className="form-group mt-3">
                  <label htmlFor="date">Date:</label>
                  <select id="date" className="form-select" value={date} onChange={onChange}>
                    <option key="empty" value="">
                      Select date
                    </option>
                    {Object.keys(staticData.dates).map((d) => (
                      <option key={d} value={d}>
                        {staticData.dates[d]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="time">Time:</label>
                  <select id="time" className="form-select" value={time} onChange={onChange}>
                    <option key="empty" value="">
                      Select time
                    </option>
                    {Object.keys(staticData.times).map((t) => (
                      <option key={t} value={t}>
                        {staticData.times[t]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="tolerance">Tolerance:</label>
                  <select id="tolerance" className="form-select" value={tolerance} onChange={onChange}>
                    <option key="empty" value="">
                      Select Tolerance
                    </option>
                    {Object.keys(staticData.tolerances).map((t) => (
                      <option key={t} value={t}>
                        {staticData.tolerances[t]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="courtTypeId">Court Type:</label>
                  <select id="courtTypeId" className="form-select" value={courtTypeId} onChange={onChange}>
                    <option key="empty" value="">
                      Select Court Type
                    </option>
                    {Object.keys(staticData.courtTypes).map((ct) => (
                      <option key={ct} value={ct}>
                        {staticData.courtTypes[ct]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="courtSurfaceId">Court Surface:</label>
                  <select id="courtSurfaceId" className="form-select" value={courtSurfaceId} onChange={onChange}>
                    <option key="empty" value="">
                      Select Court Surface
                    </option>
                    {Object.keys(staticData.courtSurfaces).map((cs) => (
                      <option key={cs} value={cs}>
                        {staticData.courtSurfaces[cs]}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group mt-3">
                  <Button className="btn btn-primary btn-large" onClick={onSetAlert} disabled={!date || !time || !tolerance || !courtTypeId || !courtSurfaceId}>
                    Set Alert
                  </Button>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default SetAlert;
